// eslint-disable-next-line import/prefer-default-export
export const muiAccordionSummaryComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      alignItems: 'center',
      columnGap: theme.spacing('SMALL'),
      minHeight: 'auto',

      [`&.Mui-expanded`]: {
        minHeight: 'auto',
      },
    }),
    content: () => ({
      margin: '0',

      [`&.Mui-expanded`]: {
        margin: '0',
      },
    }),
    expandIconWrapper: ({ theme }) => ({
      alignItems: 'center',
      height: theme.spacing('1XL'),
      justifyContent: 'center',
      width: theme.spacing('1XL'),

      [`& > svg`]: {
        height: 'fit-content',
        width: 'fit-content',
      },
    }),
  },
};
